import { PiArrowBendUpLeftLight } from "react-icons/pi";
import { useNavigate, useParams } from "react-router";
import { FormProvider } from "../../common/provider/form/Form.provider";
import { Form } from "antd";
import { Button } from "react-bootstrap";
import FormAdd from "./component/FormAdd";
import {
  getCustomerById,
  patchCustomerById,
  postNewCustomer,
} from "./core/_request";
import { toast } from "sonner";
import { SimpleInput } from "../../common/components/simpleInput";
import { useEffect, useState } from "react";
import { TitleHeader } from "../../common/components/TitleHeader/TitleHeader";
import { Loader } from "../../common/components/Loader/Loader";
import dayjs from "dayjs";

const CustomerAdd = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { id } = useParams();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const [initialValues, setInitialValues] = useState({
    customerInterlocutors: [
      {
        firstname: "",
        lastname: "",
      },
    ],
    customerEmails: [
      {
        email: "",
      },
    ],
    customerPhones: [
      {
        number: "",
      },
    ],
  });

  useEffect(() => {
    if (id) {
      loadCustomerById(id);
    }
  }, [id]);

  const loadCustomerById = async (id: string) => {
    try {
      setIsLoading(true);
      const detail = await getCustomerById(id as string);
      if (detail) {
        // setInitialValues(detail)
        const _update = {
          ...detail,
          image: detail?.image ?? null,
          ...(detail?.startWorkTime && detail?.endWorkTime
            ? {
                schedule: [
                  dayjs(`01/01/1970 ${detail?.startWorkTime}`),
                  dayjs(`01/01/1970 ${detail?.endWorkTime}`),
                ],
              }
            : {}),
          customerInterlocutors: detail.customerInterlocutors.map(
            (item: any) => {
              return {
                firstname: item?.firstname ?? "",
                lastname: item?.lastname ?? "",
              };
            }
          ),
          customerEmails: detail?.customerEmails.map((item: any) => {
            return {
              email: item?.email ?? "",
            };
          }),
          customerPhones: detail.customerPhones.map((item: any) => {
            return {
              number: item?.number ?? "",
            };
          }),
        };
        form.setFieldsValue(_update);
        setInitialValues(_update);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div className="">
      <Loader isLoading={isLoading} />
      <TitleHeader
        title={""}
        subTitle={`Gestion de client > ${id ? "Modification" : "Nouveau"}`}
        isSHowBack
      ></TitleHeader>

      <div className="card-customer mt-2">
        <div className="bg-customer" />
        <FormProvider
          initialValues={initialValues}
          Form={Form}
          form={form}
          onFinish={async (values) => {
            const getInterlocuteur = (interlocuteur: any[] = []) => {
              const customInter = interlocuteur
                ?.filter((t) => t?.firstname || t.lastname)
                .map((item: any) => {
                  return {
                    firstname: item?.firstname ?? undefined,
                    lastname: item?.lastname ?? undefined,
                  };
                });
              return customInter.length > 0 ? customInter : undefined;
            };

            const getEmail = (interlocuteur: any[] = []) => {
              const interloc = interlocuteur
                ?.filter((t) => t?.email)
                .map((item: any) => {
                  return {
                    email: item?.email ?? "",
                  };
                });
              return interloc.length > 0 ? interloc : undefined;
            };

            const getCustomer = (customer: any[] = []) => {
              const cust = customer
                ?.filter((t) => t?.number)
                .map((item: any) => {
                  return {
                    number: item?.number ?? "",
                  };
                });
              return cust.length > 0 ? cust : undefined;
            };
            setIsSubmitting(true);

            try {
              const dataToSend = {
                ...values,
                ...(values?.schedule
                  ? {
                      startWorkTime: dayjs(values?.schedule[0]).format("HH:mm"),
                      endWorkTime: dayjs(values?.schedule[1]).format("HH:mm"),
                    }
                  : {}),
                image: values.image?.["@id"] ?? values.image,
                customerInterlocutors: getInterlocuteur(
                  values.customerInterlocutors
                ),
                customerEmails: getEmail(values.customerEmails),
                customerPhones: getCustomer(values.customerPhones),
              };
              if (id) {
                const res = await patchCustomerById(id, dataToSend);
                if (res?.id) {
                  navigate(-1);
                }
              } else {
                const res = await postNewCustomer(dataToSend);
                if (res?.id) {
                  navigate(-1);
                }
              }
            } catch (error) {
              toast.error("Une erreur est survenue");
            } finally {
              setIsSubmitting(false);
            }
          }}
          onFinishFailed={(values) => {
            console.log(values);
          }}
          debug={process.env.REACT_APP_DEV_MODE as unknown as boolean}
        >
          <SimpleInput hidden Form={Form} name={"id"} />
          <FormAdd isSubmitting={isSubmitting} />
        </FormProvider>
      </div>
    </div>
  );
};

export default CustomerAdd;
